export default __webpack_public_path__ + "static/chicks-ba3c87e8e9d9b94765b3ffd706a6a40c.png";